import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/usr/src/app/apps/frontend/www/layouts/account.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/apps/frontend/www/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/usr/src/app/apps/frontend/www/layouts/landing.vue").then(m => m.default || m)),
  actions: defineAsyncComponent(() => import("/usr/src/app/shared/common/layouts/actions.vue").then(m => m.default || m))
}